import React from "react";
import { Form } from "react-bootstrap";
import { Controller, Control, FieldErrors, UseFormSetValue } from "react-hook-form";

interface BasedOnComponentProps {
    control: Control<any>;
    errors: FieldErrors<{
        filter: {
            property_id: string;
            base_on: string;
            start_date: string;
            end_date: string;
            room_type_id?: string;
        };
    }>;
    setValue: UseFormSetValue<any>;
}

const BasedOnComponent: React.FC<BasedOnComponentProps> = ({ control, errors, setValue }) => {
    return (
        <div>
            <Form.Label className="me-2">Report Based On:</Form.Label>
            <Controller
                name="filter.base_on"
                control={control}
                rules={{ required: "Report Based On is required" }}
                render={({ field }) => (
                    <>
                        <Form.Check
                            className="mt-3"
                            type="radio"
                            label="Created Reservation"
                            value="created_reservation"
                            checked={field.value === "created_reservation"}
                            onChange={() => setValue("filter.base_on", "created_reservation")}
                        />
                        <Form.Check
                            className="mt-1"
                            type="radio"
                            label="Stay Dates"
                            value="stay_date"
                            checked={field.value === "stay_date"}
                            onChange={() => setValue("filter.base_on", "stay_date")}
                        />
                    </>
                )}
            />
            {errors.filter?.base_on && (
                <span className="text-danger">{errors.filter.base_on.message}</span>
            )}
        </div>
    );
};

export default BasedOnComponent;